import {
  IonGrid,
  IonRow,
  IonCol,
  IonCard,
  IonItem,
  IonLabel,
  IonButton,
  IonIcon,
} from "@ionic/react";
import axios from "axios";
import { documentTextOutline, locationOutline, shieldOutline, fileTrayOutline, folderOutline } from "ionicons/icons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { findFileTypes } from "../../../store/fileTypes/actions/findFileTypes";
import { selectFileTypesCount } from "../../../store/fileTypes/selectors/selectFileTypesCount";
import { findTemplates } from "../../../store/templateList/actions/findTemplates";
import { findTemplatesForUserOrLocation } from "../../../store/templateList/actions/findTemplatesForUserOrLocation";
import { selectTemplateCount } from "../../../store/templateList/selectors/selectTemplateCount";
import { selectULTemplateCount } from "../../../store/templateList/selectors/selectULTemplateCount";
import { selectUser } from "../../../store/userAuthentication/selectors/selectUser";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";


export const KpisSection: React.FC = () => {
  const [counter, setCounter] = useState<{ profileCount: number, locationCount: number }>({ profileCount: 0, locationCount: 0 })
  const dispatch = useDispatch();
  const fileTypesCount = useSelector(selectFileTypesCount);
  const templatesCount = useSelector(selectTemplateCount);
  const ulTemplatesCount = useSelector(selectULTemplateCount);
  const user = useSelector(selectUser);

  const fetchCounters = async () => {
    const [{ data: profilesCount }, { data: locationCount }] =
      await Promise.all([
        axiosInstance.post(`${api.baseURL}profile/count`),
        axiosInstance.post(`${api.baseURL}location/count`,{
          where: {
            sourceOrganization: user?.sourceOrganization,
          }
        }),
      ]);
    setCounter({ profileCount: profilesCount, locationCount: locationCount });
  };

  useEffect(() => {
    fetchCounters();
    dispatch(findTemplates());
    dispatch(findTemplatesForUserOrLocation());
    dispatch(findFileTypes());
  }, [dispatch]);



  return (
    <IonGrid style={{ minHeight: "94px" }} class="ion-no-margin">
      <IonRow>
        <IonCol key="Perfiles">
          <IonCard class="ion-no-margin">
            <IonItem lines="none" color="primary">
              <IonIcon icon={shieldOutline} slot="start"></IonIcon>
              <IonLabel style={{ fontWeight: 500 }}>
                <h2>Perfiles</h2>
                <h1>{counter.profileCount}</h1>
              </IonLabel>
              <IonButton
                slot="end"
                size="small"
                color="secondary"
                class="ion-align-self-start ion-margin-top"
                routerLink="/app/tic/perfiles"
              >
                Ver todos
              </IonButton>
            </IonItem>
          </IonCard>
        </IonCol>
        <IonCol key="Instalaciones">
          <IonCard class="ion-no-margin">
            <IonItem lines="none" color="primary">
              <IonIcon icon={locationOutline} slot="start"></IonIcon>
              <IonLabel style={{ fontWeight: 500 }}>
                <h2>Instalaciones</h2>
                <h1>{counter.locationCount}</h1>
              </IonLabel>
              <IonButton
                slot="end"
                size="small"
                color="secondary"
                class="ion-align-self-start ion-margin-top"
                routerLink="/app/tic/instalaciones"
              >
                Ver todos
              </IonButton>
            </IonItem>
          </IonCard>
        </IonCol>
        <IonCol key="Tipos_de_archivos">
          <IonCard class="ion-no-margin">
            <IonItem lines="none" color="primary">
              <IonIcon icon={folderOutline} slot="start"></IonIcon>
              <IonLabel style={{ fontWeight: 500 }}>
                <h2>Tipos de archivos</h2>
                <h1>{fileTypesCount}</h1>
              </IonLabel>
              <IonButton
                slot="end"
                size="small"
                color="secondary"
                class="ion-align-self-start ion-margin-top"
                routerLink="/app/tic/tipos-de-archivos"
              >
                Ver todos
              </IonButton>
            </IonItem>
          </IonCard>
        </IonCol>
        <IonCol key="Plantillas_Generales">
          <IonCard class="ion-no-margin">
            <IonItem lines="none" color="primary">
              <IonIcon icon={documentTextOutline} slot="start"></IonIcon>
              <IonLabel style={{ fontWeight: 500 }}>
                <h2>Plantillas Generales</h2>
                <h1>{templatesCount}</h1>
              </IonLabel>
              <IonButton
                slot="end"
                size="small"
                color="secondary"
                class="ion-align-self-start ion-margin-top"
                routerLink="/app/tic/plantillas"
              >
                Ver todos
              </IonButton>
            </IonItem>
          </IonCard>
        </IonCol>
        <IonCol key="Plantillas_Archivo">
          <IonCard class="ion-no-margin">
            <IonItem lines="none" color="primary">
              <IonIcon icon={fileTrayOutline} slot="start"></IonIcon>
              <IonLabel style={{ fontWeight: 500 }}>
                <h2>Plantillas de Archivos</h2>
                <h1>{ulTemplatesCount}</h1>
              </IonLabel>
              <IonButton
                slot="end"
                size="small"
                color="secondary"
                class="ion-align-self-start ion-margin-top"
                routerLink="/app/tic/plantillas-file"
              >
                Ver todos
              </IonButton>
            </IonItem>
          </IonCard>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};
